import { WizardPageDefinition } from '@/objects/Wizard';

export class WizardContainer {
    public WizardPages: WizardPageDefinition[] = [];

    private _activeWizardPage: WizardPageDefinition | null = null;

    public get ActiveWizardPage() {
        if (!this._activeWizardPage) {
            this._activeWizardPage = this.WizardPages[0] || null;
        }
        return this._activeWizardPage;
    }

    public set ActiveWizardPage(page: WizardPageDefinition) {
        if (!this.WizardPages.includes(page)) {
            console.error(
                `Cant set page as active since the page is not a part of this pagecontainer. Tried to set page with name: ${
                    page.Name
                }. This.pages: ${this.WizardPages.join(' ')}`,
            );
            return;
        }
        this._activeWizardPage = page;
    }

    public SetActiveWizardPage(page: WizardPageDefinition) {
        this.ActiveWizardPage = page;
    }

    public get ActiveWizardPageIdx() {
        return this.WizardPages.indexOf(this.ActiveWizardPage);
    }

    /**
     * Checks if we can change to a specific page, here we probably want to validate the pages below, so some kind of validation should be sendt in to the class
     * @param page
     */
    public CanSwitchToPage(page: WizardPageDefinition): boolean {
        return true;
    }
    /**
     * Checks if a given page is the currently active page.
     * If no page has been explicitly set as active when this is called, the first page will be set as active
     * @param page The page to check if is active
     */
    public isWizardPageActive(page: WizardPageDefinition): boolean {
        return page == this.ActiveWizardPage;
    }
}
